import React from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface FormTabsProps {
  tab: 'userDetails' | 'properties' | 'setup';
  add: boolean;
  isManagerRole?: boolean;
  onTabChange: (e: any, value: 'userDetails' | 'properties' | 'setup') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, isManagerRole, onTabChange }) => {
  const { t } = useTranslation()

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor='primary'>
        <Tab value="userDetails" label={t("users.addEdit.pageTexts.form.tabs.userDetails")} />
        { !add && <Tab value="properties" label={t("users.addEdit.pageTexts.form.tabs.properties")} /> }
        { !add && isManagerRole && <Tab value="setup" label={t("users.addEdit.pageTexts.form.tabs.setup")} /> }
      </Tabs>
    </div>
  );
};

export default FormTabs;